import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/HomePage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/books/:collection/:page',
    name: 'BooksList',
    component: () => import('@/views/books/BooksList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/book/:id',
    name: 'BookDetail',
    component: () => import('@/views/books/BookDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/book/:id/read',
    name: 'BookRead',
    component: () => import('@/views/books/BookRead.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/collections/:page',
    name: 'CollectionsList',
    component: () => import('@/views/collections/CollectionsList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/collection/:id',
    name: 'CollectionDetail',
    component: () => import('@/views/collections/CollectionDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/tasks/:page',
    name: 'TasksList',
    component: () => import('@/views/tasks/TasksList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/task/:id',
    name: 'TaskDetail',
    component: () => import('@/views/tasks/TaskDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/task/:id/duplicates/:page',
    name: 'TaskDuplicates',
    component: () => import('@/views/tasks/TaskDuplicates.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/task/:id/nonbooks/:page',
    name: 'TaskNonBooks',
    component: () => import('@/views/tasks/TaskNonBooks.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/task/:id/errors/:page',
    name: 'TaskErrors',
    component: () => import('@/views/tasks/TaskErrors.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/favorites/:page',
    name: 'Favorites',
    component: () => import('@/views/books/BooksList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dict/:type/:page',
    name: 'DictList',
    component: () => import('@/views/dict/DictList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/profile/ProfilePage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/recent-books/:page',
    name: 'RecentBooks',
    component: () => import('@/views/profile/RecentBooks.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
      children: [
      {
        path: 'roles',
        name: 'AdminRoles',
        component: () => import('@/views/admin/RolesList.vue'),
      },
      {
        path: 'roles/edit/:id',
        name: 'AdminRoleEdit',
        component: () => import('@/views/admin/RoleEdit.vue'),
      },
      {
        path: 'roles/create',
        name: 'AdminRoleCreate',
        component: () => import('@/views/admin/RoleEdit.vue'),
      },
      {
        path: 'users/:page',
        name: 'AdminUsers',
        component: () => import('@/views/admin/UsersList.vue'),
      },
      {
        path: 'users/edit/:id',
        name: 'AdminUserEdit',
        component: () => import('@/views/admin/UserEdit.vue'),
      },
      {
        path: 'users/create',
        name: 'AdminUserCreate',
        component: () => import('@/views/admin/UserEdit.vue'),
      },
      {
        path: 'audit-log',
        name: 'AdminAuditLog',
        component: () => import('@/views/admin/AuditLog.vue'),
      },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

export const router = createRouter({
  history: createWebHistory('/wanderingbook/'),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const tokenParam = to.query.token
  if (tokenParam) {
    const { useAuthStore } = await import('@/stores/auth')
    const auth = useAuthStore()
    await auth.completeOidcLogin(tokenParam)
    const cleanQuery = { ...to.query }
    delete cleanQuery.token
    const redirectPath = localStorage.getItem('wanderingbook_redirect') || '/'
    localStorage.removeItem('wanderingbook_redirect')
    return next({ path: redirectPath, query: cleanQuery, replace: true })
  }

  const token = localStorage.getItem('wanderingbook_token')
  const user = JSON.parse(localStorage.getItem('wanderingbook_user') || 'null')

  if (to.meta.requiresAuth && !token) {
    if (to.path !== '/login' && to.path !== '/') {
      localStorage.setItem('wanderingbook_redirect', to.path)
    }
    return next({ path: '/login', replace: true })
  }

  if (to.meta.guest && token) {
    return next('/')
  }

  if (to.meta.requiresAdmin) {
    if (!user?.roles?.includes('admin')) {
      return next('/')
    }
  }

  next()
})
